import { createAction, createSlice } from '@reduxjs/toolkit';


export type Quote = {
    author: string,
    text: string
}


const initialState: Quote = {
    author: '',
    text: ''
};

export const revertAll = createAction('REVERT_ALL');

// Redux Toolkit slice
export const quotesReducer: any = createSlice({
    name: 'quotes',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setQuotes: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertAll, () => initialState);
    },
});
export const { setQuotes } = quotesReducer.actions;
export default quotesReducer;